var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from "moment";
import useSWR, { useSWRConfig } from "swr";
import useSWRMutation from "swr/mutation";
import { dateFilters } from "../../Account/constants";
import { LogLevel } from "../../Shared/hooks/useLogging/Logging-types";
import { useLogging } from "../../Shared/hooks/useLogging/useLogging";
import useToast from "../../hooks/useToast";
import { apFetcher } from "../Utilities/axiosPrivateFetcher_SWR";
import { refreshMultipleCaches } from "../Utilities/refreshMultipleCaches";
import { SWR_KEYS } from "../Utilities/swrKeys";
import { filterOrdersKeys } from "./swrOrders-utils";
import { updateFunction_V2 } from "./updateFunction_V2";
export const useOrdersQuery = (pageNumber, dateFilter, itemsPerPage = 10) => {
    const toast = useToast();
    const { datadogLog } = useLogging();
    const { cache, mutate } = useSWRConfig();
    const pageIndex = pageNumber - 1;
    const pageIndexKey = `page-index-${pageIndex.toString()}`;
    const dateFilterKey = `date-filter-${dateFilter.toString()}`;
    const allTime = dateFilter > dateFilters.oneYear;
    const startDate = allTime ? moment() : moment().subtract(dateFilter, "months");
    const startDateISO = startDate.clone().toISOString();
    const endDate = allTime ? moment() : moment().add(1, "day");
    const endDateISO = endDate.clone().toISOString();
    const fetchAllOrders = allTime ? true : false;
    const upcomingOrdersKey = `${SWR_KEYS.UPCOMING_ORDERS}-${pageIndexKey}`;
    const byDateOrdersKey = `${SWR_KEYS.ORDERS_BY_DATE}-${pageIndexKey}-${dateFilterKey}`;
    // Only fetch for the active filter
    let ordersQueryResponse;
    if (dateFilter === dateFilters.upcoming) {
        const upcomingQueryString = `/Account/GetUpcomingOrders?pageIndex=${pageIndex}&pageSize=${itemsPerPage}`;
        ordersQueryResponse = useSWR(upcomingOrdersKey, apFetcher(upcomingQueryString));
    }
    else {
        // Fetch by date orders only
        const byDateQueryString = `/Account/GetOrders?from=${startDateISO}&to=${endDateISO}&fetchAllOrders=${fetchAllOrders}&pageIndex=${pageIndex}&pageSize=${itemsPerPage}`;
        ordersQueryResponse = useSWR(byDateOrdersKey, apFetcher(byDateQueryString));
    }
    // SWR mutation for updating order pickup/delivery
    const MUTATION_KEY = dateFilter === dateFilters.upcoming ? upcomingOrdersKey : byDateOrdersKey;
    const { trigger: triggerUpdate } = useSWRMutation(MUTATION_KEY, updateFunction_V2, {
        onSuccess: (data) => {
            var _a;
            if (!((_a = data === null || data === void 0 ? void 0 : data.Balance) === null || _a === void 0 ? void 0 : _a.remainingBalance) || data.Balance.remainingBalance <= 0) {
                // See function for explanation of why we do this
                refreshMultipleCaches(cache, mutate, filterOrdersKeys);
            }
        },
        onError: (error) => {
            datadogLog("Orders update error", LogLevel.ERROR, undefined, error);
        },
        // Don't revalidate here, as we handle it manually (above)
        revalidate: false,
    });
    // SWR mutation trigger function
    const triggerOrderUpdate = (newAddressData, balance, giftCardId, onSuccess, onError) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const data = yield triggerUpdate({ newAddressData, giftCardId, balance });
            if (onSuccess)
                onSuccess(data);
            else
                toast.push(`Successfully updated order!`, { variant: "success" });
        }
        catch (err) {
            if (onError)
                onError(err);
            else
                toast.push("Failed to update order.", { variant: "error" });
        }
    });
    // Only return the active query response
    return {
        ordersQueryResponse,
        triggerOrderUpdate,
        isMutating: false,
    };
};
